import { render, staticRenderFns } from "./LatestDevices.vue?vue&type=template&id=6423b090&scoped=true&"
import script from "./LatestDevices.vue?vue&type=script&lang=ts&"
export * from "./LatestDevices.vue?vue&type=script&lang=ts&"
import style0 from "./LatestDevices.vue?vue&type=style&index=0&id=6423b090&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423b090",
  null
  
)

export default component.exports